var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efefef",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 6.276,
    y: 10.532,
    width: 174.25,
    height: 162.122,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "c"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    x: 114.231,
    y: 95.826,
    width: 49.719,
    height: 49.75,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "e"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "e"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    x: 68.626,
    y: 95.914,
    width: 49.604,
    height: 49.619,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "g"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "g"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    x: 22.76,
    y: 77.545,
    width: 69.164,
    height: 51.48,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "i"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "i"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "j",
    x: 22.921,
    y: 54.271,
    width: 44.843,
    height: 44.722,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "k"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "k"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "l",
    x: 46.86,
    y: 54.274,
    width: 44.733,
    height: 44.719,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "m"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "m"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "n",
    x: 63.836,
    y: 30.731,
    width: 54.48,
    height: 39.945,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "o"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "o"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "p",
    x: 92.627,
    y: 30.716,
    width: 54.493,
    height: 39.977,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "q"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "q"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.836)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-39.836)",
    stroke: "#fff",
    strokeWidth: 4,
    fill: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 98,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18.559 25.532)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -21.28, -25.53)",
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M506.764-264.291c-3.749,0-7.5-.032-11.248.016A3.593,3.593,0,0,1,492.1-266.1c-3.319-5.307-6.73-10.562-10.059-15.862a2.316,2.316,0,0,0-2.254-1.233q-9.168.077-18.336,0A2.2,2.2,0,0,0,459.311-282c-3.306,5.268-6.7,10.484-9.993,15.759a3.879,3.879,0,0,1-3.713,1.972c-7.377-.055-14.751-.019-22.128-.022-2.783,0-3.752-1.2-3.135-3.865q3.82-16.446,7.643-32.885a4.082,4.082,0,0,0,.111-.589c.027-.341.372-.721.04-1.014s-.69.045-1,.18a34.311,34.311,0,0,1-14.251,2.883,35.753,35.753,0,0,1-22.752-8.058,34.093,34.093,0,0,1-12.73-21.587c-1.732-10.848.917-20.6,8.281-28.966a35.84,35.84,0,0,1,24.277-12.2,33.943,33.943,0,0,1,14.439,1.75c1.012.348,1.308.164,1.541-.856,3.01-13.2,15.208-24.319,28.877-26.391,12.326-1.867,23.019,1.451,31.875,10a33.958,33.958,0,0,1,10.268,21.2,35.282,35.282,0,0,1-21.1,36.029,35.765,35.765,0,0,1-26.084,1.291c-1.206-.389-1.508-.087-1.765.991a29.6,29.6,0,0,1-1.321,4.1c-.368.927-.184,1.194.818,1.184,4.075-.029,8.149.032,12.224-.032a4.234,4.234,0,0,1,4.15,2.153c.848,1.452,1.9,2.79,2.823,4.2a1.6,1.6,0,0,0,1.515.788c1.63-.032,3.26-.035,4.89,0a1.585,1.585,0,0,0,1.5-.8c1.065-1.606,2.2-3.163,3.263-4.772a3.236,3.236,0,0,1,2.869-1.529c8.475-.013,16.953-.032,25.427.013,1.995.009,2.714.763,3.217,2.928q2.938,12.652,5.862,25.31,2.848,12.3,5.7,24.612c.637,2.765-.309,3.929-3.184,3.929Q512.265-264.286,506.764-264.291Zm-1.061-4.917c2.81,0,5.622-.032,8.432.013,1.061.019,1.351-.274,1.1-1.332-1.3-5.432-2.537-10.881-3.8-16.323-2.12-9.174-4.268-18.343-6.332-27.53-.3-1.322-.864-1.715-2.211-1.7-6.68.064-13.364.045-20.045.013a2.073,2.073,0,0,0-1.995,1.052c-.963,1.529-2.028,2.993-3.026,4.5a3.111,3.111,0,0,1-2.862,1.48q-4.278-.058-8.557,0a3.254,3.254,0,0,1-3.033-1.632c-.95-1.487-2-2.909-2.951-4.4a1.979,1.979,0,0,0-1.9-1q-6.905.048-13.811,0a2.044,2.044,0,0,0-1.906.994,32.581,32.581,0,0,1-7.38,7.758,3.138,3.138,0,0,0-1.262,1.941q-4.012,17.44-8.09,34.868c-.224.966-.089,1.329,1.048,1.319q8.31-.077,16.624,0A2.285,2.285,0,0,0,446-270.4c3.345-5.339,6.776-10.623,10.131-15.955a3.492,3.492,0,0,1,3.309-1.78c7.331.048,14.666.071,22-.013a4.22,4.22,0,0,1,4.062,2.237c3.256,5.249,6.638,10.427,9.924,15.656a2,2,0,0,0,1.968,1.062C500.162-269.24,502.932-269.208,505.7-269.208Zm-45-61.285a32.42,32.42,0,0,0,6.313-.589c16.187-3.153,26.492-17.908,24.944-32.583a29.741,29.741,0,0,0-8.882-18.694,31.345,31.345,0,0,0-39.113-4.045,29.816,29.816,0,0,0-13.344,19.038,1.5,1.5,0,0,0,.9,1.912,34.1,34.1,0,0,1,9.723,8.267,3.017,3.017,0,0,0,1.59,1.008,52.646,52.646,0,0,0,9.237,1.641,79.992,79.992,0,0,0,15.97.18,65.1,65.1,0,0,0,11.538-1.9,2.4,2.4,0,0,1,3.161,2.365,10.419,10.419,0,0,1-.141,2.262c-1.2,6.262-5.061,10.417-10.943,12.808-5.609,2.279-15.786,2.15-21.438-.109-1.229-.492-1.347-.441-1.18.84a24.8,24.8,0,0,1,.154,4.3,1.257,1.257,0,0,0,1,1.4A31.059,31.059,0,0,0,460.7-330.493Zm-16.667-4.46c.24-16.589-13.561-30.481-30.79-30.588-17.357-.109-31.237,13.445-31.263,30.349a30.591,30.591,0,0,0,30.905,30.572C430.154-304.6,444.021-318.1,444.037-334.953Zm17.16-7.3a19.684,19.684,0,0,0,9.25-1.429,12.958,12.958,0,0,0,6.2-5.718c.145-.267.411-.573.181-.882-.2-.27-.526-.087-.8-.051-2.458.315-4.909.718-7.38.92a76.345,76.345,0,0,1-12.073.209c-3.165-.241-6.323-.477-9.457-1-1.19-.2-1.265-.01-.94,1.1.71,2.436,2.567,3.8,4.656,4.968C454.037-342.351,457.556-342.12,461.2-342.251Z",
    transform: "translate(-355.61 421.92)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -21.28, -25.53)",
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.593-349.586a9.971,9.971,0,0,1-9.833-10.081c-.057-5.171,4.678-9.756,9.985-9.667a10.011,10.011,0,0,1,9.733,10.071A10.068,10.068,0,0,1,419.593-349.586Zm.023-5.241a4.458,4.458,0,0,0,4.644-4.509,4.573,4.573,0,0,0-4.658-4.8,4.591,4.591,0,0,0-4.641,4.684A4.447,4.447,0,0,0,419.616-354.827Z",
    transform: "translate(-280.53 480.16)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -21.28, -25.53)",
    filter: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.71-369.309a2.459,2.459,0,0,1,2.533,2.486,33.71,33.71,0,0,1,.046,3.571c-.02.835.292,1.2,1.154,1.164,1.107-.043,2.218-.036,3.325,0a2.6,2.6,0,0,1,2.728,2.579,2.529,2.529,0,0,1-2.765,2.493c-1.068.02-2.138.046-3.2-.006-.9-.043-1.283.275-1.243,1.2.047,1.064.033,2.135,0,3.2a2.733,2.733,0,0,1-2.549,2.931c-1.482.033-2.586-1.2-2.632-2.974-.03-1.107-.026-2.218-.007-3.325.01-.723-.285-1.044-1.027-1.024-1.19.03-2.384.026-3.574-.006a2.5,2.5,0,0,1-2.6-2.4,2.564,2.564,0,0,1,2.526-2.649c1.187-.066,2.38-.06,3.571-.016.9.033,1.13-.4,1.11-1.2-.026-1.147-.046-2.3.02-3.448A2.519,2.519,0,0,1,405.71-369.309Z",
    transform: "translate(-312.27 480.22)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -21.28, -25.53)",
    filter: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.576-374.987q7.946,0,15.9,0c2.669,0,3.574.879,3.517,3.557-.073,3.56.488-.8-.324,2.732a19.616,19.616,0,0,1-19.973,15.173,19.622,19.622,0,0,1-18.336-16.562c-.507-3.381-.419,1.139-.372-2.262.023-1.7,1.18-2.622,3.08-2.632,4.273-.023,8.543-.007,12.816-.01Zm.187,4.47c-4.31,0-8.619.027-12.929-.016-1.114-.01-1.353.348-1.041,1.392a16.158,16.158,0,0,0,2.781,5.308c.56.723,5.393,5.091,10.943,5.069s10.645-4.4,11.258-5.158a15.536,15.536,0,0,0,2.755-5.318c.285-.935.133-1.309-.965-1.3C410.3-370.484,406.029-370.517,401.762-370.517Z",
    transform: "translate(-344.19 467.53)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -21.28, -25.53)",
    filter: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.4-368.49a7.409,7.409,0,0,1-7.406-7.343,7.4,7.4,0,0,1,7.492-7.38,7.412,7.412,0,0,1,7.35,7.4A7.419,7.419,0,0,1,389.4-368.49Zm-2.185-7.416a2.2,2.2,0,0,0,2.171,2.32,2.176,2.176,0,0,0,2.215-2.145,2.192,2.192,0,0,0-2.105-2.38A2.192,2.192,0,0,0,387.216-375.906Z",
    transform: "translate(-344.07 452.48)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -21.28, -25.53)",
    filter: "url(#l)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.635-368.492a7.25,7.25,0,0,1-7.306-7.366,7.255,7.255,0,0,1,7.439-7.353,7.362,7.362,0,0,1,7.293,7.422A7.385,7.385,0,0,1,396.635-368.492Zm.033-5.1a2.316,2.316,0,0,0,2.281-2.258,2.321,2.321,0,0,0-2.284-2.258,2.218,2.218,0,0,0-2.234,2.261A2.208,2.208,0,0,0,396.669-373.594Z",
    transform: "translate(-327.47 452.48)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -21.28, -25.53)",
    filter: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.581-379.864a14.651,14.651,0,0,1-11.431-5.619,2.493,2.493,0,0,1,.129-3.647,2.523,2.523,0,0,1,3.557.13c.335.3.623.653.942.974a9.475,9.475,0,0,0,14.175-.368,7.743,7.743,0,0,1,.67-.719,2.461,2.461,0,0,1,3.362-.063,2.476,2.476,0,0,1,.4,3.438,13.185,13.185,0,0,1-2.977,2.924A14.111,14.111,0,0,1,406.581-379.864Z",
    transform: "translate(-315.59 435.54)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -21.28, -25.53)",
    filter: "url(#p)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.426-379.837a14.674,14.674,0,0,1-11.49-5.636,2.47,2.47,0,0,1,.109-3.637,2.527,2.527,0,0,1,3.812.375,10.37,10.37,0,0,0,5.761,3.54c3.64.7,6.6-.567,9.067-3.2a3.178,3.178,0,0,1,2.612-1.383,2.5,2.5,0,0,1,2.178,1.578,2.554,2.554,0,0,1-.6,2.841A15.242,15.242,0,0,1,415.426-379.837Z",
    transform: "translate(-295.57 435.53)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFun);
export default __webpack_public_path__ + "static/media/Fun.8c1c0931562f6bbe8fc6fb748349d171.svg";
export { ForwardRef as ReactComponent };